import { render, staticRenderFns } from "./Rights.vue?vue&type=template&id=0c65cec6&scoped=true"
import script from "./Rights.vue?vue&type=script&lang=js"
export * from "./Rights.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c65cec6",
  null
  
)

export default component.exports